import { render, staticRenderFns } from "./PageRenderer.vue?vue&type=template&id=f5ba5418&scoped=true&"
import script from "./PageRenderer.vue?vue&type=script&lang=js&"
export * from "./PageRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PageRenderer.vue?vue&type=style&index=0&id=f5ba5418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba5418",
  null
  
)

/* custom blocks */
import block0 from "./PageRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports